<div class="questionnaire-field-spacer d-flex flex-column">
    <p-multi-select
            [formControl]="formControl"
            [optionValue]="props.optionValue"
            [optionLabel]="props.optionLabel"
            [placeholder]="props.placeholderText | translate"
            [filter]="props.canFilter"
            [showClear]="props.canClear"
            [options]="props.selectOptions"
            [showToggleAll]="false"></p-multi-select>
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
